import type { Gate, GateContext } from './types'

/**
 * Runs the gate pipeline in order. `deny` short-circuits to false, `allow`
 * short-circuits to true, `pass` continues. If no gate decides, returns
 * `undefined` — the caller then defers to CASL's `ability.can()`, which has the
 * final word. Gates never widen access beyond CASL (they are deny-biased).
 */
export const runGates = (gates: Gate[], context: GateContext): boolean | undefined => {
  for (const gate of gates) {
    const result = gate.evaluate(context)

    if (result.type === 'deny') {
      return false
    }

    if (result.type === 'allow') {
      return true
    }
  }

  return undefined
}
